import { render, staticRenderFns } from "./appoint-check.vue?vue&type=template&id=ed76baee"
import script from "./appoint-check.vue?vue&type=script&lang=ts"
export * from "./appoint-check.vue?vue&type=script&lang=ts"
import style0 from "./appoint-check.vue?vue&type=style&index=0&id=ed76baee&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports